
















import { Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ResultImage extends Vue {
  $refs: {
    figure: HTMLElement
  };
  failedImages: string[] = [];
  @Prop({ default: false })
  flipImageOnHover: boolean;
  hasEnteredView = !this.isIntersectionObserverAvailable;
  hover = false;
  @Prop({ required: true })
  item: Result;

  get hoverEvents() {
    return this.flipImageOnHover
      ? {
        mouseenter: this.enableHover,
        mouseleave: this.disableHover
      }
      : {};
  }

  get imageSrc(): string {
    return !this.hasEnteredView ?
      ''
      : this.hover && this.images.length > 1
        ? this.images[1]
        : this.images[0];
  }

  get images() {
    return this.item.images.filter(image => !this.failedImages.includes(image));
  }

  get isIntersectionObserverAvailable() {
    return 'IntersectionObserver' in window;
  }

  get renderErrorSlot(): boolean {
    return this.failedImages.length === this.item.images.length;
  }

  mounted() {
    if (this.isIntersectionObserverAvailable) {
      this.createObserver();
    }
  }

  createObserver() {
    const image = this.$refs.figure;
    const observer = new IntersectionObserver(this.observerHandler);
    observer.observe(image);
  }

  disableHover() {
    this.hover = false;
  }

  enableHover() {
    this.hover = true;
  }

  flagImageAsFailed() {
    this.failedImages.push(this.imageSrc);
  }

  observerHandler(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.hasEnteredView = true;
        observer.disconnect();
      }
    });
  }
}
